import { Component, ViewChild, Input, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
import { ContratoService } from 'src/app/contrato/contrato.service';

declare var $: any;
@Component({
	selector: 'app-form-contrato-anexo',
  	templateUrl: './form-contrato-anexo.component.html',
  	styleUrls: ['./form-contrato-anexo.component.scss']
})
export class FormContratoAnexoComponent{
	@ViewChild('Swal') public swal:SwalComponent;
	@ViewChild('SwalDelete') public swalDelete:SwalComponent; 
	@Input() anexos;
	@Input() contrato_id: number;
	@Input() detalhe:boolean;
	@Input() pessoa_status: string = 'A';
	form: FormGroup;
	anexo_id:number = null;
	modalTitle:string;
	submitted: boolean = false;
	loading: boolean = false;
	modalReference: NgbModalRef;   
	arquivo: File;
    
	constructor(private contratoService: ContratoService, private formBuilder: FormBuilder,private modalService: NgbModal){
        this.form = this.formBuilder.group({
			descricao: this.formBuilder.control('',[Validators.required])
		})
	}
	onFileChange(event){
		this.arquivo = event.target.files[0];	
	}
	onSubmit(){
		this.submitted = true;
        if(!this.form.valid)
		return;
		this.modalReference.close();
		if(!this.anexo_id){
			this.contratoService.addAnexo(this.contrato_id, this.form, this.arquivo)
			.subscribe( (success) => {
				this.swal.text = "Anexo cadastrado com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
			return;
		}

		this.contratoService.editAnexo(this.contrato_id, this.form, this.arquivo)
			.subscribe( (success) => {
				this.swal.text = "Anexo atualizado com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});

        
	}

	openModal(modal,id:number = null) {
		//Se id == null então é cadastro.
		if(!id){
			this.anexo_id = null;
			this.modalTitle = "Cadastrar Anexo";
			this.form.patchValue({
				descricao: ''
			});
			this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
			return;
		}
		
		//Senão é edição.
		this.anexo_id = id;
		this.modalTitle = "Editar Anexo";
		this.contratoService.getAnexoById(id).subscribe((success) => {
			this.form.patchValue({
				descricao: success.dados.descricao
			});
			this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
		})
	}

	askDelete(id:number){
		this.anexo_id = id;
		this.swalDelete.show();
	}

	confirmDelete(){
		this.contratoService.delAnexo(this.anexo_id).subscribe( 
		(success) => {
			this.swal.text = "Anexo deletado com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
			this.submitted = false;
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
			this.submitted = false;
		});
	}

	onCloseModal(){
		if(this.swal.type == "success"){
			this.contratoService.getContratoById(this.contrato_id).subscribe((success)=>{
				this.anexos = success.dados.anexos;
				this.submitted = false;
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
		}
	}
}